<template lang="pug">
.crud
  div(v-if="has_permission")
    modal-submittals(:submittal='submittal', :is-add='isModalAdd' :customer="isCustomer")
    .container-fluid
      vm-row.separador-row(vm-w="12")
        vm-col(vm-lg=6 vm-sm=6)
        vm-col(vm-type="flex" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" @click="addSubmittal" v-if="submittals_store_permission") {{ $t('strings.add') }}
      vm-row(vm-w="12")
        vm-col(vm-sm=12)
          vm-table(v-model="selected" :data="submittals")
            template(slot="header")
              .d-flex.justify-content-between
                div
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('submittals.' + column) }}

            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  div(@click="addDetails(data[indextr], tr)")
                    slot(v-if="column != 'status' && column != 'total' && column != 'approved' && column != 'created_by' && column != 'type' && column != 'approved_date' && column != 'starting_date' && column != 'end_date'") {{data[indextr][column]}}
                    slot(v-if="column == 'created_by'") {{data[indextr]['user']['name']}}
                    iconRevission(v-if="column == 'approved'" :approved="data[indextr]['approved'] == 1 ? true : false")
                    vm-chip(v-if="column == 'type'") {{ data[indextr]['type_display']}}
                    vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                    slot(v-if="column == 'approved_date'") {{data[indextr]['approved_date'] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'starting_date'") {{data[indextr]['starting_date'] | moment("DD MMMM YYYY") }}
                    slot(v-if="column == 'end_date'") {{data[indextr]['end_date'] | moment("DD MMMM YYYY") }}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteSubmittalConfirm(data[indextr])" v-if="submittals_update_permission")
                        vm-icon(icon="trash-2-outline")
                        slot &nbsp;{{ $t('strings.delete') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="setActionSubmittal(data[indextr], 'approved')" v-if="data[indextr]['status'] !== 2 && submittals_update_permission")
                        vm-icon(icon="checkmark-circle-2-outline")
                        slot &nbsp;{{ $t('strings.approved') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="setActionSubmittal(data[indextr], 'revise')" v-if="data[indextr]['status'] !== 3 && submittals_update_permission")
                        vm-icon(icon="refresh-outline")
                        slot &nbsp;{{ $t('strings.revise_and_resubmit') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="setActionSubmittal(data[indextr], 'for-record')" v-if="data[indextr]['status'] !== 4 && submittals_update_permission")
                        vm-icon(icon="slash-outline")
                        slot &nbsp;{{ $t('strings.for_record_only') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="setActionSubmittal(data[indextr], 'make-corrections')" v-if="data[indextr]['status'] !== 5 && submittals_update_permission")
                        vm-icon(icon="alert-triangle-outline")
                        slot &nbsp;{{ $t('strings.make_corrections_as_noted') }}
                      vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr], indextr)" v-if="data[indextr].attachment && data[indextr].attachment.filename && submittals_update_permission")
                        vm-icon(icon="eye-outline")
                        slot &nbsp;{{ $t('submittals.see_attachment') }}
  #no-access(v-else)
    access-denied
</template>
<script>
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'Submittals',
  components: {
    ModalSubmittals: () => import('@/components/in-order/ModalSubmittals.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue'),
    iconRevission: () => import('@/components/aditionals/iconRevission.vue')
  },
  data: () => ({
    submittal: {},
    selected: [],
    isModalAdd: true,
    has_permission: true,
    submittals_store_permission: true,
    submittals_update_permission: true,
    customer: true,
    isCustomer: true,
    columns: [
      'submittal_number',
      'package_name',
      'type',
      'status',
      'created_by',
      'approved',
      'approved_date',
      'starting_date',
      'end_date'
    ],
    status: [
      {
        text: 'Open',
        value: 1,
        color: 'secondary'
      },
      {
        text: 'Approved',
        value: 2,
        color: 'success'
      },
      {
        text: 'Revise and Resubmit',
        value: 3,
        color: 'warning'
      },
      {
        text: 'For Record Only',
        value: 4,
        color: 'dark'
      },
      {
        text: 'Make Corrections as Noted',
        value: 5,
        color: 'danger'
      }
    ]
  }),
  async created () {
    this.checkPermission('submittals.index')
    this.$route.params.id && await this.getSubmittals()
  },
  methods: {
    ...mapActions([
      'setModalSubmittalVisible',
      'deleteSubmittal',
      'actionSubmittal',
      'loadSubmittals'
    ]),
    checkPermission (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.submittals_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'submittals.store') > -1
      this.submittals_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'submittals.update') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    async getSubmittals () {
      this.loadSubmittals(this.$route.params)
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    addSubmittal () {
      this.isModalAdd = true
      this.isCustomer = this.customer
      this.submittal = {
        starting_date: moment().format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        type: 2
      }
      this.setModalSubmittalVisible(true)
    },
    addEndDate (submittal, index) {
      this.isModalAdd = false
      this.submittal = { ...submittal }
      this.submittal.end_date = moment().format('YYYY-MM-DD')
      this.setModalSubmittalVisible(true)
    },
    async deleteSubmittalConfirm (submittal) {
      let t = this
      this.auxDeleteSubmittal = () => {
        t.deleteSubmittal(submittal).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.submittal'), attribute: this.$t(submittal.id) }),
        accept: this.auxDeleteSubmittal
      })
    },
    openViewer (submittal) {
      this.$viewer.show({
        urlFile: submittal.attachment.file_url,
        mime: submittal.attachment.mime_type,
        name: submittal.attachment.filename,
        color: '#FFF'
      })
    },
    addDetails (submittal, index) {
      this.$router.push(`/in-orders/${this.inOrder.id}/submittal/${submittal.id}`)
    },
    async setActionSubmittal (record, action) {
      record.id && this.actionSubmittal({ id: record.id, action })
    }
  },
  computed: {
    ...mapGetters([
      'inOrder',
      'submittals'
    ])
  }
}
</script>
<style lang="scss" scoped>
  .card {
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
  .separador-row {
    margin: 20px 5px;
  }
  .filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
  }
  .con-vm-tooltip {
  display: inline-block;
  position: relative;
  }
  .vm-table--header {
  padding: 10px;
  span {
    width: 100%;
    .justify-content-between {
      div:last-child {
        .vm-button {
          margin: 0 3px;
        }
        .vm-con-dropdown {
          float: left;
        }
        .con-select {
          display: inline-block;
          input {
            height: 32px;
          }
        }
      }
    }
  }
}
</style>
